// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Account from '../components/Account';
import {actions as ProfileAction} from '../duck';
import {actions as CheckoutAction} from '../../../checkout/duck';
import {actions as AuthAction} from '../../../auth/duck';

import type {RootState} from '../../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    store: state.store.store,
    user: state.auth.user,
    isSaving: state.accountConfig.isSaving,
    error: state.accountConfig.error,
    savingSuccess: state.accountConfig.savingSuccess,
    subscription: state.tiersList.currentSubscription,
    dueInformation: state.tiersList.dueInformation,
    subscriptionSetting: state.accountConfig.subscriptionSetting,
    cardProfiles: state.checkout.cardProfiles,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {
        ...ProfileAction,
        ...AuthAction,
        ...CheckoutAction,
      },
      dispatch
    )
)(Account);
